import { render, staticRenderFns } from "./AboutBranch.vue?vue&type=template&id=4be11544"
import script from "./AboutBranch.vue?vue&type=script&lang=js"
export * from "./AboutBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports